import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightMedium = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.026 8.3901L20.474 13.9961H2.95996V17.9961H20.474L15.026 23.6001L17.896 26.3901L27.996 15.9961L17.896 5.6001L15.026 8.3901Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowRightMedium);
export { ForwardRef as ReactComponent };
